import React from 'react';
import voiceapp from '../../../assets/voice-app.png';
import { IE } from 'country-flag-icons/react/3x2'
import React1 from '../../../assets/react-logo.png'
import AWS from '../../../assets/amazon-logo.png'
import Flutter from '../../../assets/flutter-logo.png'
import Graph from '../../../assets/graphQL.png'
import Connect from '../../Connect.jsx'
import commonbanner from '../../../assets/common-banner.png'
import { Link } from 'react-router-dom';


const Voiceapp = () => {
  return (
    <>
      {/* Intro banner */}
      <div className="grid grid-cols-2 gap-10 pt-24 pl-60 my-20">
      <div className="flex items-center justify-center flex-col">
        <div className="flex items-center justify-center text-6xl font-[Montserrat] font-extrabold text-center">
          Voice Chat Web App For Scalable Decision Making
        </div>
        <div className="flex items-center justify-center text-xl font-[Montserrat] font-extrabold text-center mt-20 px-24">
          A highly scalable and engaging voice based SaaS platform that enables scalable decision-making for civic participation, corporations, and institutions.
      </div>
      </div>
      <img src={voiceapp} alt="food" className='w-[592px] h-[521px] rounded-xl shadow-md ml-40' />
      </div>
      {/* small banner */}
    <div className="flex flex-row justify-evenly bg-sec1 py-10">
        <div className="font-prime font-bold flex flex-col">
          Client
        <div className="font-prime font-medium">SURU Together</div>
        </div>
        <div className="font-prime font-bold flex flex-col">
          Project Type
        <div className="font-prime font-medium">Design & Development - Web App</div>
        </div>
        <div className="font-prime font-bold flex flex-col">
          Duration
        <div className="font-prime font-medium">14 weeks</div>
        </div>
        <div className="font-prime font-bold flex flex-col">
          Industry
        <div className="font-prime font-medium">Media and Communication</div>
        </div>
        <div className="font-prime font-bold flex flex-col ">
          Platform
        <div className="font-prime font-medium">Web App</div>
        </div>
        <div className="font-prime font-bold flex flex-col">
          Country
      <div className="font-prime font-medium flex items-center justify-center"> <IE title="Ireland" style={{width: '40px', height: '40px', marginRight: '10px'}}/> Ireland</div>  
        </div>  
      </div>
      {/* business objective */}
      <div className="py-20">
        <div className="flex items-center justify-center text-6xl font-[Montserrat] font-extrabold text-center">Business Objectives</div>
        <div className="font-prime text-xl font-normal text-center mt-20 px-60">Founders of PSi, Georgina Denis and Niccolo Pescetelli proposed a comprehensive decision-making platform for real-time critical decisions. We developed an intuitive audio platform that simplifies the decision-making process through anonymous live conversations and effortless voting.</div>
        <div className="flex flex-row justify-evenly mt-20">
          <div className="flex flex-col items-center justify-center">
            <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_401_26832)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M65.25 36C65.25 43.7576 62.1683 51.1974 56.6829 56.6829C51.1974 62.1683 43.7576 65.25 36 65.25C28.2424 65.25 20.8026 62.1683 15.3171 56.6829C9.83169 51.1974 6.75 43.7576 6.75 36C6.75 28.2424 9.83169 20.8026 15.3171 15.3171C20.8026 9.83169 28.2424 6.75 36 6.75C43.7576 6.75 51.1974 9.83169 56.6829 15.3171C62.1683 20.8026 65.25 28.2424 65.25 36ZM72 36C72 45.5478 68.2072 54.7045 61.4558 61.4558C54.7045 68.2072 45.5478 72 36 72C26.4522 72 17.2955 68.2072 10.5442 61.4558C3.79285 54.7045 0 45.5478 0 36C0 26.4522 3.79285 17.2955 10.5442 10.5442C17.2955 3.79285 26.4522 0 36 0C45.5478 0 54.7045 3.79285 61.4558 10.5442C68.2072 17.2955 72 26.4522 72 36ZM31.5 27C31.5 28.1935 31.0259 29.3381 30.182 30.182C29.3381 31.0259 28.1935 31.5 27 31.5C25.8065 31.5 24.6619 31.0259 23.818 30.182C22.9741 29.3381 22.5 28.1935 22.5 27C22.5 25.8065 22.9741 24.6619 23.818 23.818C24.6619 22.9741 25.8065 22.5 27 22.5C28.1935 22.5 29.3381 22.9741 30.182 23.818C31.0259 24.6619 31.5 25.8065 31.5 27ZM36 54C39.5804 54 43.0142 52.5777 45.5459 50.0459C48.0777 47.5142 49.5 44.0804 49.5 40.5H22.5C22.5 44.0804 23.9223 47.5142 26.4541 50.0459C28.9858 52.5777 32.4196 54 36 54ZM49.5 27C49.5 28.1935 49.0259 29.3381 48.182 30.182C47.3381 31.0259 46.1935 31.5 45 31.5C43.8065 31.5 42.6619 31.0259 41.818 30.182C40.9741 29.3381 40.5 28.1935 40.5 27C40.5 25.8065 40.9741 24.6619 41.818 23.818C42.6619 22.9741 43.8065 22.5 45 22.5C46.1935 22.5 47.3381 22.9741 48.182 23.818C49.0259 24.6619 49.5 25.8065 49.5 27Z" fill="#2C2D36"/>
            </g>
            <defs>
            <clipPath id="clip0_401_26832">
            <rect width="72" height="72" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            <div className="font-prime font-bold text-xl mt-10">Ease of use</div>
            <div className="font-prime font-normal text-xl mt-10 px-24 text-center">No plugins and no apps. Just go to web and start talking. As simple as that.</div>
          </div>
          <div className="flex flex-col items-center justify-center">
            <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 45C23.2044 45 22.4413 45.3161 21.8787 45.8787C21.3161 46.4413 21 47.2044 21 48C21 48.7956 21.3161 49.5587 21.8787 50.1213C22.4413 50.6839 23.2044 51 24 51C24.7956 51 25.5587 50.6839 26.1213 50.1213C26.6839 49.5587 27 48.7956 27 48C27 47.2044 26.6839 46.4413 26.1213 45.8787C25.5587 45.3161 24.7956 45 24 45ZM33 48C33 47.2044 33.3161 46.4413 33.8787 45.8787C34.4413 45.3161 35.2044 45 36 45C36.7956 45 37.5587 45.3161 38.1213 45.8787C38.6839 46.4413 39 47.2044 39 48C39 48.7956 38.6839 49.5587 38.1213 50.1213C37.5587 50.6839 36.7956 51 36 51C35.2044 51 34.4413 50.6839 33.8787 50.1213C33.3161 49.5587 33 48.7956 33 48ZM48 45C47.2044 45 46.4413 45.3161 45.8787 45.8787C45.3161 46.4413 45 47.2044 45 48C45 48.7956 45.3161 49.5587 45.8787 50.1213C46.4413 50.6839 47.2044 51 48 51C48.7956 51 49.5587 50.6839 50.1213 50.1213C50.6839 49.5587 51 48.7956 51 48C51 47.2044 50.6839 46.4413 50.1213 45.8787C49.5587 45.3161 48.7956 45 48 45Z" fill="#2C2D36"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 9C9.61305 9 7.32387 9.94821 5.63604 11.636C3.94821 13.3239 3 15.6131 3 18V54C3 56.3869 3.94821 58.6761 5.63604 60.364C7.32387 62.0518 9.61305 63 12 63H60C62.3869 63 64.6761 62.0518 66.364 60.364C68.0518 58.6761 69 56.3869 69 54V18C69 15.6131 68.0518 13.3239 66.364 11.636C64.6761 9.94821 62.3869 9 60 9H12ZM60 15H12C11.2044 15 10.4413 15.3161 9.87868 15.8787C9.31607 16.4413 9 17.2044 9 18V21H63V18C63 17.2044 62.6839 16.4413 62.1213 15.8787C61.5587 15.3161 60.7957 15 60 15ZM9 54V27H63V54C63 54.7957 62.6839 55.5587 62.1213 56.1213C61.5587 56.6839 60.7957 57 60 57H12C11.2044 57 10.4413 56.6839 9.87868 56.1213C9.31607 55.5587 9 54.7957 9 54Z" fill="#2C2D36"/>
</svg>

            <div className="font-prime font-bold text-xl mt-10">Voice (Audio) Communication</div>
            <div className="font-prime font-normal text-xl mt-10 px-40 text-center">To build an easy-to-use and engaging web based app system for all user age groups.</div>
          </div>
          <div className="flex flex-col items-center justify-center">
            <svg width="42" height="57" viewBox="0 0 42 57" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 0C23.3869 0 25.6761 0.948212 27.364 2.63604C29.0518 4.32387 30 6.61305 30 9V27C30 29.3869 29.0518 31.6761 27.364 33.364C25.6761 35.0518 23.3869 36 21 36C18.6131 36 16.3239 35.0518 14.636 33.364C12.9482 31.6761 12 29.3869 12 27V9C12 6.61305 12.9482 4.32387 14.636 2.63604C16.3239 0.948212 18.6131 0 21 0ZM42 27C42 37.59 34.17 46.32 24 47.79V57H18V47.79C7.83 46.32 0 37.59 0 27H6C6 30.9782 7.58035 34.7936 10.3934 37.6066C13.2064 40.4196 17.0218 42 21 42C24.9782 42 28.7936 40.4196 31.6066 37.6066C34.4196 34.7936 36 30.9782 36 27H42Z" fill="#2C2D36"/>
</svg>


            <div className="font-prime font-bold text-xl mt-10">Web Experience</div>
            <div className="font-prime font-normal text-xl mt-10 px-24 text-center">Capture audio inputs at scale. Build scalable audio breakout rooms where users can talk using their phone.</div>
          </div>
        </div>
      </div>
      {/* project development */}
      <div className="flex flex-row my-20 bg-sec1">
        <div className="flex flex-col py-20 text-5xl text-center font-prime font-extrabold w-[2000px] items-center justify-center">
          Project Development Considerations
        </div>
        <div className="flex flex-col py-20 text-xl font-prime font-normal pr-24 ml-40">
          With our experience in live audio and video communications, we identified the following critical aspects of the system.
          <li className=''>Scale: Building a scalable microservices architecture using serverless AWS lambda.</li>
          <li className="">CPaaS: Use proven audio SDK and audio chat capabilities from Agora.io to build robust live audio conversations.</li>
          <li className=''>Subscriptions: Use of Hasura based subscriptions for managing the user states and facilitating the time sync.</li>
        </div>
      </div>
      {/* tech stack */}
      <div className="flex items-center justify-center font-prime font-extrabold text-4xl mt-20">Tech Stack Used</div>
      <div className="grid grid-cols-4 px-10 my-20">
            <div className="flex flex-col w-1/4 ml-10">
                  <img src={React1} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2 text-black">React</div>
            </div>
            <div className="flex flex-col w-1/4 ml-20">
                  <img src={AWS} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2 text-black">AWS</div>
            </div>
            <div className="flex flex-col w-1/4 ml-40">
                  <img src={Flutter} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2 text-black">Flutter</div>
            </div>
            <div className="flex flex-col w-1/4 ml-80">
                  <img src={Graph} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2 text-black">GraphQL</div>
            </div>
      </div>
      {/*  result */}
      <div className="bg-sec1 flex flex-col">
        <div className="flex flex-row my-20">
          <div className="flex flex-col w-1/2">
            <div className="text-center font-prime font-bold text-5xl mt-32">Result</div>
            <div className="text-center font-prime font-normal text-xl mt-10 px-44 text-wrap">We were able to launch the first version in 10 weeks. Our agile iterations and constant feedback from clients helped us to roll out the product with limited challenges.
The system was ready for scalable decisions with capabilities like:
Ability to share audio and text-based ideas
Time-bound discussions and voting for thousands of users in parallel
Voting and intelligent idea routing
Anonymous real-time audio chats and conversations
Audio recordings and live discussions views for the admin</div>
          </div>
          <img src={voiceapp} alt="food" className='w-[516px] h-[442px] rounded-xl shadow-md' />
        </div>
        <div className="flex flex-row items-center justify-evenly my-10">
          <div className="flex flex-row w-auto border rounded-full p-8">
            <div className="font-prime font-bold text-prime text-2xl">16 weeks</div>
            <div className="text-xl ml-2">Zero to launch</div>
          </div>
          <div className="flex flex-row w-auto border rounded-full p-8">
            <div className="font-prime font-bold text-prime text-2xl">300</div>
            <div className="text-xl ml-2">Users in real time audio discussions</div>
          </div>
        </div>
      </div>
      {/* comments */}
      <div className="my-20 flex flex-col items-center justify-center">
        <div className="font-prime text-5xl px-[520px] font-bold">"What distinguished RaftLabs from other providers was their fantastic ability to build real-time engagement-based products. We wanted to build a platform that was partly a social media channel and partly like Zoom where people could interact with each other in real-time, and they did an awesome job doing that. "</div>
        <div className="font-prime text-xl font-normal mt-10 pr-[400px]">Georgina Denis, Co-Founder, SURU Together</div>
      </div>
      {/* suggestion section */}
      <div className="bg-sec1 flex flex-col py-20">
        <div className="text-prime font-prime font-bold text-4xl flex items-center justify-center">Related Projects</div>
        <div className="grid grid-cols-2 gap-10 mx-20 pb-10 my-20 w-full px-40">
      <div className="flex flex-col mb-10">
        <img src={commonbanner} alt='' className='shadow-md p-0 rounded-xl w-[530px] h-[455px]' />
        <div className="font-prime font-semibold text-2xl mt-5 text-wrap pr-60">Mobile App For Events, Membership Clubs, And Communities</div>
        <div className="flex flex-row my-8 gap-10">
          <div className="font-prime font-bold shadow-md p-3 rounded-3xl flex flex-row w-32">
              <div className="bg-[#CE1126] h-2 w-5 mr-3 mt-1 ml-2"></div>India
          </div>
          <div className="font-prime font-bold shadow-md p-3 rounded-3xl w-32 flex items-center justify-center">
            Mobile
          </div>
        </div>
        <div className="font-prime font-normal text-2xl text-gray-500 pr-60">Transforming ideas into reality, our app development company created a cutting-edge mobile app for events, membership clubs, and communities to organize conferences, events, meetings, and conventions.</div>
        <Link to='/work/events-app' className="text-prime flex text-xl font-bold font-[Montserrat] mt-5">
          See Our Approach <ion-icon name="arrow-forward-outline"></ion-icon>
        </Link> 
      </div>
      <div className="flex flex-col mb-10">
        <img src={commonbanner} alt='' className='shadow-md p-0 rounded-xl w-[530px] h-[455px]' />
        <div className="font-prime font-semibold text-2xl mt-5 text-wrap pr-20">TikTok Style Social Commerce Mobile App</div>
        <div className="flex flex-row my-8 gap-10">
          <div className="font-prime font-bold shadow-md p-3 rounded-3xl flex flex-row w-52">
              <div className="bg-[#CE1126] h-2 w-8 mr-3 mt-1 ml-2"></div>United States
          </div>
          <div className="font-prime font-bold shadow-md p-3 rounded-3xl w-32 flex items-center justify-center">
            Mobile
          </div>
        </div>
        <div className="font-prime font-normal text-2xl text-gray-500 pr-40">With our app development expertise, we successfully delivered a highly engaging creator, brand collaboration, and marketplace mobile app, offering a TikTok / Instagram style content experience.</div>
        <Link to='/work/ticktok' className="text-prime flex text-xl font-bold font-[Montserrat] mt-5">
          See Our Approach <ion-icon name="arrow-forward-outline"></ion-icon>
        </Link> 
      </div>
     </div>
      </div>
      {/* connect banner */}
      <Connect />
      {/*  */}
    </>
  )
}

export default Voiceapp